<template>
  <section class="content">
    <admin-header
      title="Routing Rules"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:entity-quick-search="search"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:csv-upload="multiSave"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    name: 'AdminRoutingRule',
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    data () {
      return {
        newEntityScreen: 'Admin - Routing Rules',
        searchEntityScreen: 'Admin - Routing Rule search',
        filterEventName: 'admin-routing-rule-filter',
        filterName: 'RoutingRuleFilter',
        entityName: 'routing-rules',
        transformFilterRequest: true
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/RoutingRule/AdminRoutingRule.vue